export const decodeJwtPayload = (token: string): Record<string, unknown> => {
	const payload = token.split('.')[1];
	return JSON.parse(atob(payload));
};
